import { useStoreSelector } from '@hook/store/store.hooks';

export const useUserGuide = () => useStoreSelector((store) => store.user.data.guides);
